import script from "./BasePagination.vue?vue&type=script&setup=true&lang=ts"
export * from "./BasePagination.vue?vue&type=script&setup=true&lang=ts"

import "./BasePagination.vue?vue&type=style&index=0&id=7044746f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7044746f"]])

export default __exports__